// Illinois State University's majors (#2739). Read on 2026-10-01 from the official
// Illinois State University Catalog, 2026-2027 (catalog.illinoisstate.edu, a
// Coursedog catalog; the list was read from the catalog's own program search
// data): every active undergraduate program of type Major that the catalog
// displays, grouped by the college that owns it. Each degree is listed
// separately with the catalog's abbreviation (BA, BS, BSED, BFA, BM, BME,
// BSN, BSW). Names are the catalog's, without the degree suffix and with
// "and" for its ampersands. Left out: minors, certificates, sequences within
// majors, graduate programs, the Integrated Bachelor of Science/Master of
// Professional Accountancy, and inactive or undisplayed program records.
// Interdisciplinary Studies is run by the Office of the Provost.
const majors = {
    "slug": "illinois-state-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Illinois State's official 2026-2027 Catalog, by college, with each degree it leads to. Minors, sequences, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Illinois State University Catalog 2026-2027, College of Arts and Sciences",
                "url": "https://catalog.illinoisstate.edu/departments/CASAO/overview"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences Teacher Education",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Systems Science and Sustainability",
                    "degree": "BS"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BS"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Language and Culture Studies",
                    "degree": "BA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BS"
                },
                {
                    "name": "Mass Media",
                    "degree": "BA"
                },
                {
                    "name": "Mass Media",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Molecular and Cellular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Sports Communication",
                    "degree": "BA"
                },
                {
                    "name": "Sports Communication",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Applied Science and Technology",
            "source": {
                "label": "Illinois State University Catalog 2026-2027, College of Applied Science and Technology",
                "url": "https://catalog.illinoisstate.edu/departments/CSTAO/overview"
            },
            "majors": [
                {
                    "name": "Agriculture",
                    "degree": "BS"
                },
                {
                    "name": "Computer Networking",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Systems Technology",
                    "degree": "BS"
                },
                {
                    "name": "Construction Management",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Health and Sustainability",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Family and Consumer Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Family and Consumer Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Design and Merchandising",
                    "degree": "BA"
                },
                {
                    "name": "Fashion Design and Merchandising",
                    "degree": "BS"
                },
                {
                    "name": "Food, Nutrition, and Dietetics",
                    "degree": "BA"
                },
                {
                    "name": "Food, Nutrition, and Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Graphic Communications Technology",
                    "degree": "BS"
                },
                {
                    "name": "Health Informatics and Management",
                    "degree": "BS"
                },
                {
                    "name": "Health Promotion and Education",
                    "degree": "BS"
                },
                {
                    "name": "Health Promotion and Education",
                    "degree": "BSED"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BA"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Interior Design",
                    "degree": "BA"
                },
                {
                    "name": "Interior Design",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Occupational Safety and Health",
                    "degree": "BS"
                },
                {
                    "name": "Physical Education",
                    "degree": "BS"
                },
                {
                    "name": "Physical Education",
                    "degree": "BSED"
                },
                {
                    "name": "Recreation and Sport Management",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable and Renewable Energy",
                    "degree": "BS"
                },
                {
                    "name": "Technology and Engineering Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "Illinois State University Catalog 2026-2027, College of Business",
                "url": "https://catalog.illinoisstate.edu/departments/COBAO/overview"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Business Education",
                    "degree": "BA"
                },
                {
                    "name": "Business Education",
                    "degree": "BS"
                },
                {
                    "name": "Business Education",
                    "degree": "BSED"
                },
                {
                    "name": "Business Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "International Business",
                    "degree": "BA"
                },
                {
                    "name": "International Business",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "Illinois State University Catalog 2026-2027, College of Education",
                "url": "https://catalog.illinoisstate.edu/departments/COEAO/overview"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BSED"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BSED"
                },
                {
                    "name": "Middle Level Teacher Education",
                    "degree": "BS"
                },
                {
                    "name": "Middle Level Teacher Education",
                    "degree": "BSED"
                },
                {
                    "name": "Special Education",
                    "degree": "BSED"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Illinois State University Catalog 2026-2027, College of Engineering",
                "url": "https://catalog.illinoisstate.edu/departments/CEGAO/overview"
            },
            "majors": [
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Wonsook Kim College of Fine Arts",
            "source": {
                "label": "Illinois State University Catalog 2026-2027, Wonsook Kim College of Fine Arts",
                "url": "https://catalog.illinoisstate.edu/departments/CFAAO/overview"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art",
                    "degree": "BS"
                },
                {
                    "name": "Creative Technologies",
                    "degree": "BA"
                },
                {
                    "name": "Creative Technologies",
                    "degree": "BS"
                },
                {
                    "name": "Film",
                    "degree": "BA"
                },
                {
                    "name": "Film",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Music",
                    "degree": "BME"
                },
                {
                    "name": "Music",
                    "degree": "BS"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Mennonite College of Nursing",
            "source": {
                "label": "Illinois State University Catalog 2026-2027, Mennonite College of Nursing",
                "url": "https://catalog.illinoisstate.edu/departments/MCNAO/overview"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Interdisciplinary Studies",
            "source": {
                "label": "Illinois State University Catalog 2026-2027, Programs",
                "url": "https://catalog.illinoisstate.edu/programs"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
